import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import CurdForm from "@/components/BaseCurd/form";
import * as configs from "./config";
import { isDisplayShow } from "@/utils/index";
@Component({
  CurdForm,
})
export default class AdvancedSearch extends Vue {
  @Prop(String) readonly type: string;
  @Prop({ default: () => [] }) readonly filters: Array<any>;
  @Prop({type:String, default:'130px'}) top!:string;
  @Prop({type:String, default:''}) subTitle!:string;
  
  @Ref() readonly form!: CurdForm;

  showDrawer = false;
  schema = {};
  show = false;

  @Watch("type", { immediate: true })
  async onTypeChange(value, oldValue) {
    if (value === oldValue) return;
    this.getSchema(value, this.filters);
  }

  @Watch("filters", { immediate: true })
  async onFiltersChange(value, oldValue) {
    if (value === oldValue) return;
    this.getSchema(this.type, value);
  }

  async getSchema(type, filters) {
    const pick = filters.reduce((result, { isDisplay, code, title }) => {
      if (!isDisplayShow(isDisplay, 4)) return result;
      const key = code.replace(/[A-Z]/g, (v) => "_" + v.toLowerCase());
      let index = configs[type].findIndex(item => key.indexOf(item) > -1)
      if (configs[type].includes(key) || index > -1) {
        result[key] = title;
      }
      return result;
    }, {});
    const keys = Object.keys(pick);
    this.show = !!keys.length;
    const config = configs.getConfig(keys, this.$t.bind(this));
    this.schema = Object.keys(config).reduce((result, key) => {
      const { suffix, ...rest } = config[key];
      result[`${key}_${suffix}`] = {
        ...rest,
        label: pick[key],
      };
      return result;
    }, {});
  }

  submitSearch() {
    this.form
      .manualSubmit()
      .then((data) => {
        Object.keys(data).forEach((key) => {
          if (key.includes("start_time") && data[key]) {
            data[key] += " 00:00:00";
          }
          if (key.includes("end_time") && data[key]) {
            data[key] += " 23:59:59";
          }
        });
        this.$emit("search", data);
      })
      .catch((err) => {
        this.$message.error(err);
      });
  }
  resetForm(){
    this.form.resetForm()
  }
  showAdvancedSearch(){
    if(this.show){
      this.showDrawer = !this.showDrawer
    } else {
      this.$message.warning(this.$t('page_plan_no_search_info'))
    }
  }

  render() {
    return (
      <div>
        <a-button
          icon="filter"
          onClick={() => this.showAdvancedSearch()}
          // v-show={}
        >
          {this.$t("page_my_document_advanced")}
        </a-button>
        <dragModal
          title={this.$t("page_my_document_advanced")}
          subTitle={this.subTitle}
          width={'430px'}
          top={this.top}
          visible={this.showDrawer}
          onClose={() => (this.showDrawer = false)}
        >
          <CurdForm ref="form" type="edit" schema={this.schema} footer={null} />

          <div
            slot="footer"
            style={{
              padding:"10px",
              textAlign: "center",
            }}
          >
            <a-button type="primary" onClick={this.submitSearch}>
              {this.$t("common_search")}
            </a-button>
            <a-button type="default" style="margin-left:10px;" onClick={this.resetForm}>
              {this.$t("common_reset")}
            </a-button>
          </div>
        </dragModal>
      </div>
    );
  }
}
